<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="labels" :label="$lang.labels" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="ticks" :label="$lang.ticks" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :disabled="!ticks" v-model="tickFractions" :label="$lang.tickFractions" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="vertical" :label="$lang.vertical" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="disabled" :label="$lang.disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col equal-height :span="12" md12 sm12 xs24 v-for="(slider, index) in sliders" :key="index">
        <card full-height align="center">
          <card-text>
            <slider
              @input="onInput"
              v-model="slider.value"
              :color="$root.colors.primary"
              :height="height"
              :width="width"
              :labels="labels"
              :tick-fractions="tickFractions"
              :class="['margin-auto']"
              :color-lightness="$root.colors.bgColorLightness"
              :label-color="$dark ? 'white' : 'black'"
              :label-color-lightness="null"
              :ticks="ticks"
              :disabled="disabled"
              :vertical="vertical"
              :min="slider.min"
              :max="slider.max"
              :step="slider.step" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk>v-model: {{ slider.value }} / {{ $lang.step.toLowerCase() }}: {{ slider.step }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageSlider',
  mixins: [
    methods
  ],
  data () {
    return {
      vertical: false,
      labels: true,
      ticks: true,
      tickFractions: true,
      height: '128px',
      width: '100%',
      disabled: false,
      sliders: []
    }
  },
  mounted () {
    this.getExternalData('slider.json', 'sliders')
  },
  methods: {
    onInput ($event) {
      this.log('input', 'slider', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/slider.vue